import { mediaContactInfo as schema } from 'web/schemas/contentful/_schema.mjs';
import { fakeProps } from 'web/schemas/contentfulTestData';

const TestData = {
  header: 'Press Inquiries',
  description:
    'If you need further press material, please feel free to contact one of the Engel and Volkers real estate representatives listed',
  agents: [
    {
      image: '/assets/test.png',
      name: 'Katelyn Castellano',
      title: 'Senior VP of Marketing',
      region: 'EV North America',
      email: 'Esmec@evamericas.com',
      phone: '(818) 555-5555',
    },
    {
      image: '/assets/yachtplaceholder.png',
      name: 'Rachel Provenzano',
      title: 'Vice President',
      region: 'Mission Control Marketing',
      email: 'rachel@missioncontrol.com',
      phone: '(234) 467-8646',
    },
  ],
};

export default fakeProps(schema, TestData);
